import React, { useEffect, useState } from 'react'
import PrintersApp, { IPrinterModel } from './PrintersApp'
import { Avatar, Button, Skeleton } from '@mui/material'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import BasicModalWindow from '../../components/BasicModalWIndow'
import PrintersList from './PrintersList'
import ItemsApp, { IItemModel } from '../items/ItemsApp'
import GenerateIcon from '../../components/GenerateIcon'
import { LoadingButton } from '@mui/lab'

interface IPrintingContainerItemsProps {
    itemId: number,
    excludedItemIds: number[],
    setExcludedItems: (items: number[]) => void
}

interface ISingleContainedItemForPrintingProps extends IItemModel {
    excludedItemIds: number[],
    setExcludedItems: (items: number[]) => void
}

export function SingleContainedItemForPrinting(props: ISingleContainedItemForPrintingProps){

    const {
        id,
        title,
        thumbnail,
        setExcludedItems,
        excludedItemIds
    } = props

    return(
        <div className="single-transcation-order">
            <div className="content-of-single-transcation-order">


                <div className="boxes-of-single-transcation-order">
                    <div className="content-of-boxes-of-single-transcation-order">

                        <div className="info-box-of-single-transcation-order" style={{ maxWidth: 50, minWidth: 50 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <Avatar src={thumbnail} style={{ width: 50, height: 50 }}>
                                    <GenerateIcon icon="image" />
                                </Avatar>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Item:</h3>
                                <p>{title}</p>
                            </div>
                        </div>


                    </div>
                </div>

                <div className="buttons-of-single-transcation-order">
                    <div className="content-of-buttons-of-single-transcation-order">
                            
                        <LoadingButton 
                            style={{ height: 45 }} 
                            className="general-button" 
                            color="error" 
                            variant="text" 
                            onClick={() => {
                                if (excludedItemIds.includes(id)) {
                                    setExcludedItems(excludedItemIds.filter(x => x !== id))
                                } else {
                                    setExcludedItems([...excludedItemIds, id])
                                }
                            }}
                        >
                            Delete
                        </LoadingButton>

                    </div>
                </div>

            </div>
        </div>
    )
}

export function PrintingContainerItems(props: IPrintingContainerItemsProps){

    const dispatch = useDispatch()

    const {
        itemId,
        setExcludedItems,
        excludedItemIds
    } = props

    const [items, setItems] = useState<IItemModel[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const itemsApp = new ItemsApp()

    const loadItems = () => {
        setLoading(true)

        itemsApp.returnContainerItemList(itemId)
            .then(response => {

                const {
                    data
                } = response

                setItems(data)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })

    }

    useEffect(() => {
        loadItems()
    }, [itemId])

    /**
     * Render refresh button
     */
    const renderRefreshButton = () => {
        if (loading){
            return <></>
        }

        return(
            <div style={{marginTop: 10, display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Button className="general-buton" startIcon={<GenerateIcon icon="refresh" />} onClick={() => loadItems()}>Refresh</Button>
            </div>
        )
    }

    /**
     * Render items
     */
    const renderPrinters = () => {
        if (loading){
            return(
                <>
                    <Skeleton variant="rectangular" width={"100%"} height={75} style={{ marginBottom: 5 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={75} style={{ marginBottom: 5 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={75} style={{ marginBottom: 5 }} />
                </>
            )
        }

        if (items.length > 0){
            return items.map((item, index) => {
                if (excludedItemIds.some((it) => it === item.id)){
                    return <></>
                }

                return <SingleContainedItemForPrinting {...item} key={index} setExcludedItems={setExcludedItems} excludedItemIds={excludedItemIds} />
            })
        }

        return <p>No items found</p>
    }

    return(
        <div className="excluded-items-from-print-list">
            <div className="content-of-excluded-items-from-print-list">
                {renderPrinters()}
                {renderRefreshButton()}
            </div>
        </div>
    )
}

interface IPrintItemLabelButtonProps {
    itemId: number,
    isItemContainer?: boolean,
}

export default function PrintItemLabelButton(props: IPrintItemLabelButtonProps) {

    const dispatch = useDispatch()

    const {
        itemId,
        isItemContainer,
    } = props

    const [loading, setLoading] = useState(false)

    const [open, setOpen] = useState<boolean>(false)
    const [containedItemsModalStatus, setContainedItemsModalStatus] = useState<boolean>(false)
    const [excludedItemModealStatus, setExcludedItemsModalStatus] = useState<boolean>(false)

    const [copies, setCopies] = useState<number>(1)
    const [printerKey, setPrinterKey] = useState<string>("")
    const [exludedItemsList, setExcludedItemsList] = useState<number[]>([])

    const printerApp = new PrintersApp()

    const onPrint = async (itemId: number, printerKey: string, print_contained_items: boolean = false) => {
        try {
            setLoading(true);

            const res = await printerApp.printItemLabel(itemId, {
                printer_key: printerKey,
                copies,
                print_contained_items,
                exclude_item_ids: exludedItemsList
            });

            console.log("Print job queued:", res.job_id);

        } catch (err: any) {
            console.error(err);
            const message = err?.response?.data?.detail ?? err?.message ?? "Failed to print label"

            handleRequestError({
                message: message
            }, dispatch)
        } finally {
            setLoading(false)
            handleCloseModal()
            setContainedItemsModalStatus(false)
            setExcludedItemsModalStatus(false)
        }
    }

    const handleOpenModal = () => setOpen(true)

    const handleCloseModal = () => {
        setOpen(false)
        setPrinterKey("")
        setExcludedItemsList([])
    }

    const handleOnPrinterClick = (printer: IPrinterModel) => {
        setPrinterKey(printer.printer_key)

        if (isItemContainer){
            setContainedItemsModalStatus(true)
        }else{
            onPrint(itemId, printer.printer_key)
        }
    }

    return(
        <>
            <BasicModalWindow
                shown={open}
                handleClose={handleCloseModal}
                showHeader
                title="Select Printer"
                size="md"
                actionButtons={[
                    {
                        label: "Close",
                        color: "error",
                        onClick: () => handleCloseModal(),
                        variant: "text"
                    }
                ]}
                actionButtonsBottom
            >
                <PrintersList handleOnClick={handleOnPrinterClick} printingLoaing={loading} />
            </BasicModalWindow>

            <BasicModalWindow
                shown={containedItemsModalStatus}
                handleClose={() => setContainedItemsModalStatus(false)}
                size="sm"
                actionButtons={[
                     {
                        label: "No",
                        color: "error",
                        onClick: () => onPrint(itemId, printerKey, false),
                        variant: "text"
                    },
                    {
                        label: "Print all",
                        color: "success",
                        onClick: () => setExcludedItemsModalStatus(true),
                        variant: "text"
                    }
                ]}
                actionButtonsBottom
            >
                <p>Item is a container. Would you like to print all items stickers?</p>
            </BasicModalWindow>

            <BasicModalWindow
                shown={excludedItemModealStatus}
                handleClose={() => setExcludedItemsModalStatus(false)}
                size="lg"
                actionButtons={[
                    {
                        label: "Print",
                        color: "success",
                        onClick: () => onPrint(itemId, printerKey, true),
                        variant: "text"
                    },
                                        {
                        label: "Cancel",
                        color: "error",
                        onClick: () => {
                            setExcludedItemsModalStatus(false)
                            setExcludedItemsList([])
                        },
                        variant: "text"
                    },
                ]}
                actionButtonsBottom
                showHeader
                title="Exclude Items From Print"
            >
                <PrintingContainerItems itemId={itemId} setExcludedItems={setExcludedItemsList} excludedItemIds={exludedItemsList} />
            </BasicModalWindow>

            <Button className="general-button" onClick={() => handleOpenModal()} disabled={loading}>
                {loading ? "Printing…" : "Print label"}
            </Button>
        </>
    )
}